import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.some";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import d2MenuSide from "./components/menu-side";
import d2MenuHeader from "./components/menu-header";
import d2Tabs from "./components/tabs";
import d2HeaderFullscreen from "./components/header-fullscreen";
import d2HeaderLocales from "./components/header-locales";
import d2HeaderSearch from "./components/header-search";
import d2HeaderSize from "./components/header-size";
import d2HeaderTheme from "./components/header-theme";
import d2HeaderUser from "./components/header-user";
import d2HeaderLog from "./components/header-log";
import d2HeaderColor from "./components/header-color";
import { mapState, mapGetters, mapActions } from "vuex";
import { updUserPassword } from "@/api/index/index";
import mixinSearch from "./mixins/search";
import ResizeHandler from "./mixins/ResizeHandler";
import IntelligentChat from "./components/Intelligent-chat";
export default {
  name: "d2-layout-header-aside",
  mixins: [mixinSearch, ResizeHandler],
  components: {
    d2MenuSide: d2MenuSide,
    d2MenuHeader: d2MenuHeader,
    d2Tabs: d2Tabs,
    d2HeaderFullscreen: d2HeaderFullscreen,
    d2HeaderLocales: d2HeaderLocales,
    d2HeaderSearch: d2HeaderSearch,
    d2HeaderSize: d2HeaderSize,
    d2HeaderTheme: d2HeaderTheme,
    d2HeaderUser: d2HeaderUser,
    d2HeaderLog: d2HeaderLog,
    d2HeaderColor: d2HeaderColor,
    IntelligentChat: IntelligentChat
  },
  data: function data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: "200px",
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: "65px",
      asideRight: 0,
      password: '',
      detailWidth: 200
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("d2admin", {
    keepAlive: function keepAlive(state) {
      return state.page.keepAlive;
    },
    grayActive: function grayActive(state) {
      return state.gray.active;
    },
    transitionActive: function transitionActive(state) {
      return state.transition.active;
    },
    asideCollapse: function asideCollapse(state) {
      return state.menu.asideCollapse;
    },
    asideTransition: function asideTransition(state) {
      return state.menu.asideTransition;
    },
    device: function device(state) {
      return state.menu.device;
    },
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    },
    isOverview: function isOverview(state) {
      return state.user.isOverview;
    },
    dialogVisible: function dialogVisible(state) {
      return state.system.pas;
    } // GameTypeList: (state) => state.init.GameTypeList,
    // GameTypeId: (state) => state.init.GameTypeId,

  })), mapState('d2admin/menu', ['aside'])), {}, {
    showChatIcon: function showChatIcon() {
      return this.aside && this.aside.some(function (menu) {
        return menu.path === '/system/chat_helper';
      });
    }
  }, mapGetters("d2admin", {
    themeActiveSetting: "theme/activeSetting"
  })), {}, {
    /**
     * @description 用来实现带参路由的缓存
     */
    routerViewKey: function routerViewKey() {
      // 默认情况下 key 类似 __transition-n-/foo
      // 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
      var stamp = this.$route.meta["__stamp-".concat(this.$route.path)] || "";
      return "".concat(stamp ? "__stamp-".concat(stamp, "-") : "").concat(this.$route.path);
    },

    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup: function styleLayoutMainGroup() {
      return this.themeActiveSetting.backgroundImage ? {
        backgroundImage: "url('".concat(this.$baseUrl).concat(this.themeActiveSetting.backgroundImage, "')")
      } : {};
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.dragControllerDiv();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), mapActions("d2admin/menu", ["asideCollapseToggle", "asideCollapseSet"])), {}, {
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside: function handleToggleAside() {
      this.asideCollapseToggle();
    },
    handleClose: function handleClose() {
      this.$store.commit('d2admin/system/setPas', false);
    },
    updPassword: function updPassword() {
      var _this2 = this;

      updUserPassword({
        password: this.password
      }).then(function (res) {
        if (res.status == 200) {
          _this2.$message.success('修改成功');

          _this2.$store.commit('d2admin/system/setPas', false);

          setTimeout(function () {
            _this2.logout({
              confirm: false
            });
          }, 1000);
        }
      });
    },
    openOv: function openOv() {
      this.asideCollapseSet(true);
      this.$router.push('/overview');
    },
    selectChange: function selectChange(e) {
      this.$store.dispatch("d2admin/init/setTypeId", e);
    },
    dragControllerDiv: function dragControllerDiv() {
      // 保留this引用
      var data = this;
      var resize = document.getElementById("resize");
      var point = document.getElementById("point");

      resize.onmousedown = function (e) {
        // 颜色改变提醒
        point.style.background = "#818181";
        var startX = e.clientX;
        resize.left = resize.offsetLeft;

        document.onmousemove = function (e) {
          // 计算并应用位移量
          var endX = e.clientX;
          var moveLen = endX - startX;
          startX = endX;
          data.detailWidth += moveLen;

          if (data.detailWidth < 200) {
            data.detailWidth = 200;
          } else if (data.detailWidth > 500) {
            data.detailWidth = 500;
          }
        };

        document.onmouseup = function () {
          // 颜色恢复
          point.style.background = "";
          document.onmousemove = null;
          document.onmouseup = null;
        };

        return false;
      };
    },
    openChat: function openChat() {
      this.$refs.IntelligentChat.open();
    }
  })
};